package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.internal.concurrent.ThreadLocalRef
import top.wcpe.allincore.ui.runtime.theme.ThemeLookup
import kotlin.jvm.JvmStatic

/**
 * 属性写入上下文 ThreadLocal。
 *
 * [PropAppliers.apply] 是各 Contributor 的统一入口，它没有元素 id / screenId 上下文，
 * 因此 LOGGER 输出的 WARN 无法定位来源；本类提供 ThreadLocal 标签，
 * 调用方（[IrInterpreter.applyValue]）在 apply 前后 push/pop 当前 screen + 元素 id 标签。
 *
 * 同时承载可选 [ThemeLookup]，供 `controlSize` / `textStyle` 解析 component token。
 *
 * 不可重入栈：apply 期间不会再嵌套调用 apply，因此用单值 ThreadLocal 即可。
 */
object PropApplyContext {

    private class Frame {
        var label: String = ""
        var themeLookup: ThemeLookup? = null
    }

    private val FRAME = ThreadLocalRef { Frame() }

    /** 进入一次 apply：记录 "screenId#elementId.key" 形式的来源标签。 */
    @JvmStatic
    fun enter(label: String) {
        enter(label, null)
    }

    /** 进入一次 apply，并注入可选主题 lookup。 */
    @JvmStatic
    fun enter(label: String, themeLookup: ThemeLookup?) {
        val frame = FRAME.get()
        frame.label = label
        frame.themeLookup = themeLookup
    }

    /** 离开 apply：清空标签与 lookup，避免被后续无关线程读取。 */
    @JvmStatic
    fun exit() {
        val frame = FRAME.get()
        frame.label = ""
        frame.themeLookup = null
    }

    /** 取当前来源标签；未设置时返回空串。 */
    @JvmStatic
    fun currentLabel(): String = FRAME.get().label

    /** 取当前主题 lookup；未注入时返回 null。 */
    @JvmStatic
    fun currentThemeLookup(): ThemeLookup? = FRAME.get().themeLookup
}
